import './DateInputField.scss';

import moment from 'moment';
import React from 'react';

import DatePicker from '@/src/components/common/DatePicker/DatePicker';

import FieldWrapper from '../FieldWrapper/FieldWrapper';

const DateInputField = ({
  value,
  label,
  labelClassName = '',
  labelWidthClasses = '',
  isRequired,
  isAiGenerated = false,
  onChange,
  disabled = false,
}) => {
  const handleChange = (date) => {
    onChange(date ? moment(date).format('YYYY-MM-DD') : null);
  };

  return (
    <FieldWrapper
      label={label}
      required={isRequired}
      labelClassName={labelClassName}
      labelWidthClasses={labelWidthClasses}
    >
      <DatePicker
        inline
        useWeekdaysShort={true}
        shouldCloseOnSelect={false}
        selected={value ? moment(value) : null}
        onChange={handleChange}
        dateFormat={'DD-MMM YYYY'}
        class={isAiGenerated && '!tw-bg-[rgba(240,232,250,1)]'}
        disabled={disabled}
      />
    </FieldWrapper>
  );
};

export default DateInputField;
